export default __webpack_public_path__ + "static/media/Call.1ad33a6d.svg";